import api from './api';
import { RTIOfficer, RTIOfficerFormData, ApiResponse } from '../../types/rti-officers.types';

class RTIOfficersService {
  private readonly endpoint = '/api/rti-officers';

  async getAll(section?: number): Promise<ApiResponse<RTIOfficer[]>> {
    const params = section ? { section } : {};
    const response = await api.get<ApiResponse<RTIOfficer[]>>(this.endpoint, { params });
    return response.data;
  }

  async getBySection(sectionNumber: number): Promise<ApiResponse<RTIOfficer[]>> {
    const response = await api.get<ApiResponse<RTIOfficer[]>>(this.endpoint, {
      params: { section: sectionNumber }
    });
    return response.data;
  }

  async getByPost(post: string): Promise<ApiResponse<RTIOfficer[]>> {
    const response = await api.get<ApiResponse<RTIOfficer[]>>(`${this.endpoint}/post/${post}`);
    return response.data;
  }

  async getStatistics(): Promise<ApiResponse<{
    totalOfficers: number;
    totalSections: number;
    appellateAuthorities: number;
    pios: number;
    apios: number;
  }>> {
    const response = await api.get(`${this.endpoint}/statistics`);
    return response.data;
  }

  async getById(id: number): Promise<ApiResponse<RTIOfficer>> {
    const response = await api.get<ApiResponse<RTIOfficer>>(`${this.endpoint}/${id}`);
    return response.data;
  }

  async create(officerData: RTIOfficerFormData): Promise<ApiResponse<RTIOfficer>> {
    const response = await api.post<ApiResponse<RTIOfficer>>(this.endpoint, officerData);
    return response.data;
  }

  async update(id: number, officerData: Partial<RTIOfficerFormData>): Promise<ApiResponse<RTIOfficer>> {
    const response = await api.put<ApiResponse<RTIOfficer>>(`${this.endpoint}/${id}`, officerData);
    return response.data;
  }

  async delete(id: number): Promise<ApiResponse<void>> {
    const response = await api.delete<ApiResponse<void>>(`${this.endpoint}/${id}`);
    return response.data;
  }

  async toggleStatus(id: number): Promise<ApiResponse<RTIOfficer>> {
    const response = await api.put<ApiResponse<RTIOfficer>>(`${this.endpoint}/${id}/toggle-status`);
    return response.data;
  }

  async search(searchTerm: string): Promise<ApiResponse<RTIOfficer[]>> {
    const response = await api.get<ApiResponse<RTIOfficer[]>>(this.endpoint, {
      params: { search: searchTerm }
    });
    return response.data;
  }
}

export const rtiOfficersService = new RTIOfficersService();
